import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessAdminShell } from '../../constants/adminRoles';

/**
 * Nested-route gate. AdminRoute already ensures a shell role.
 * @param {{ allowedRoles: string[], children: React.ReactNode }} props
 */
export default function AdminRoleGate({ allowedRoles, children }) {
  const { adminRole, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  // LEGACY_ADMIN_ALLOWLIST: claim-less users who passed AdminRoute are treated as super_admin.
  const effectiveRole = adminRole || 'super_admin';
  if (allowedRoles.includes(effectiveRole)) return children;
  if (canAccessAdminShell(adminRole)) {
    return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  }
  return <Navigate to="/" replace />;
}
